export default function HeroSection() {
  return (
    <header className="relative w-full h-screen min-h-[700px] flex flex-col overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            'url(https://readdy.ai/api/search-image?query=Dark%20forest%20green%20abstract%20atmospheric%20background%20with%20subtle%20organic%20geometric%20textures%2C%20deep%20emerald%20tones%2C%20soft%20gradient%20lighting%2C%20minimalist%20corporate%20feel%2C%20no%20text%2C%20no%20people%2C%20clean%20modern%20aesthetic%2C%20sophisticated%20atmospheric%20depth%20with%20layered%20translucent%20shapes&width=1600&height=1000&seq=tanengata-hero-bg&orientation=landscape)',
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-primary-950/70 via-primary-900/50 to-primary-950/80" />

      <div className="relative z-10 w-full px-8 md:px-14 pt-10 md:pt-14">
        <h1 className="font-heading text-white text-lg md:text-xl tracking-widest font-medium">
          SOFTWARE TANENGATA LIMITED
        </h1>
      </div>

      <div className="relative z-10 flex-1 flex flex-col justify-center w-full px-8 md:px-14">
        <div className="max-w-4xl">
          <span className="inline-block px-5 py-2 rounded-full bg-primary-400/20 text-primary-100 text-sm md:text-base font-medium tracking-wide mb-8 md:mb-10">
            Professional Engineering Team
          </span>

          <p className="font-heading text-white text-4xl md:text-6xl lg:text-7xl font-bold leading-tight tracking-tight max-w-3xl">
            Designing modern software
            <br />
            for the iOS platform
            <br />
            and beyond.
          </p>

          <p className="text-primary-100/80 text-base md:text-lg mt-8 max-w-xl leading-relaxed">
            Scalable, maintainable, and high-performance systems built with clean
            architecture, performance optimisation, and user-centred design.
          </p>
        </div>
      </div>

      <div className="relative z-10 w-full pb-10 md:pb-14">
        <p className="font-heading text-white/15 text-7xl md:text-9xl lg:text-[11rem] font-bold leading-none px-4 md:px-14 whitespace-nowrap overflow-hidden">
          ENGINEERING EXCELLENCE
        </p>
      </div>
    </header>
  );
}